import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBackRounded';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import Button, { ButtonProps } from '../Button';
import Link from '../Link';

import {
  BackButton, Caption, Content, Title, TitleContainer,
} from './index.styles';

interface ButtonType extends ButtonProps {
  label: string;
}
export interface ContentWrapperProps {
  children: React.ReactElement | React.ReactElement[],
  title?: string | React.ReactElement,
  caption?: string | React.ReactElement | React.ReactElement[],
  dense?: boolean,
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  buttons?: ButtonType[],
  backButtonHref?: string | number,
}

const ContentWrapper = ({
  children,
  title,
  caption,
  titleVariant = 'h6',
  dense = false,
  buttons = [],
  backButtonHref,
}: ContentWrapperProps) => {
  const navigate = useNavigate();

  return (
    <>
      {title && (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <TitleContainer>
            {backButtonHref && (
              typeof backButtonHref === 'number' ? (
                <BackButton onClick={() => navigate(backButtonHref)}>
                  <ArrowBackIcon />
                </BackButton>
              ) : (
                <Link href={backButtonHref} underline="none" color="inherit">
                  <BackButton>
                    <ArrowBackIcon />
                  </BackButton>
                </Link>
              )
            )}
            <Title variant={titleVariant}>{title}</Title>
          </TitleContainer>
          <Stack direction="row" spacing={1}>
            {buttons.map((button) => (
              <Button
                key={button.label}
                size="small"
                {...button}
              >
                {button.label}
              </Button>
            ))}
          </Stack>
        </Stack>
      )}
      {caption && (
        typeof caption === 'string' ? (
          <Caption>
            <Typography variant="caption">
              {caption}
            </Typography>
          </Caption>
        ) : caption
      )}
      <Content $titled={!!title} $dense={dense}>
        {children}
      </Content>
    </>
  );
};

export default ContentWrapper;
